import * as yup from 'yup';

export const EditCreditValueSchema = yup.object({
    value: yup.number().required('Errors.required').min(0, 'Errors.must_be_positive'),
});
